<template>
    <HeroSection :icon="QrCodeIcon" featureName="Badges & Kiosk">
        <template #title>Check-in experiences to <span class="text-primary-500">wow</span> your attendees</template>
        <template #description>
            <div>Entegy provides as suite of tools to let you design and plan your badge and registration desk experiences
                with ease.</div>
            <div class="mt-4">Deploy and manage on site with intuitive and powerful staff tools.</div>

        </template>
        <template #content>
            <div class="w-full relative h-[500px]">
                <BadgeAndKiosk :sceneIndex="sceneIndex" :hideOverflow="false" />

                <div v-reveal class="absolute bottom-0 right-0 w-64 h-64 ">
                    <img src="/src/images/megaphone.svg" alt="Badge" class="w-full h-full object-contain" />
                </div>
            </div>
        </template>
    </HeroSection>


    <FlexibleDeployments />
    <BadgeEditor />
    <QrCodes />

    <WorksWith title="Badges & Kiosks" :integrations="integrations" />
    <Tips title="Badges & Kiosks" :tips="tips" />
    <Cta />

</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import HeroSection from '../../components/HeroSection.vue'
import QrCodeIcon from '@heroicons/vue/24/outline/QrCodeIcon'
import WorksWith from '../../components/Blocks/WorksWith.vue'
import Tips from '../../components/Blocks/Tips.vue'
import QrCodes from '../../components/Features/Badge/QrCodes.vue'
import FlexibleDeployments from '../../components/Features/Badge/FlexibleDeployments.vue'
import BadgeEditor from '../../components/Features/Badge/BadgeEditor.vue'
import DeviceWrapper from '../../components/DeviceWrapper.vue'
import AppFeatures from '../../components/Layouts/AppFeatures.vue'
import Cta from '../../components/Blocks/Cta.vue'

import BadgeAndKiosk from '@/components/BadgeAndKiosk.vue';

import { getFeaturesByIds } from '../../router/features'

const sceneIndex = ref(0)
const SCENE_COUNT = 3
let rotationInterval

onMounted(() => {
    rotationInterval = setInterval(() => {
        sceneIndex.value = (sceneIndex.value + 1) % SCENE_COUNT
    }, 5000)
})

onUnmounted(() => {
    clearInterval(rotationInterval)
})

const integrations = getFeaturesByIds(['leadcapture', 'attendancetracking', 'eventapp'])



const tips = [
    'Queue and Email to send on the morning of the event with instructions for your check-in setup.',
    'Use Colour rules to change the appearance of your badges to quickly identify attendees.',
    'Think about the demographic of your attendees and create registration flows that are easy to understand and use. Hardware Partners are an excellent resource to help you design the perfect setup for your event.',
]

const steps = [
    {
        icon: QrCodeIcon,
        title: 'Connect & Authorize Devices',
        description: 'Connect and authorize kiosks or print servers in seconds.'
    },
    {
        icon: QrCodeIcon,
        title: 'Scan QRs or Search for Attendees',
        description: 'Scan QR codes or search for attendees by name or email.'
    },
    {
        icon: QrCodeIcon,
        title: 'Create Profiles or Update Attendee Details',
        description: 'Create profiles for attendees or update their details in real time.'
    },
    {
        icon: QrCodeIcon,
        title: 'Print Badges',
        description: 'Print badges to any connected device in your Event network.'
    },
    {
        icon: QrCodeIcon,
        title: 'View Statistics',
        description: 'View statistics for your event in real time.'
    },
    {
        icon: QrCodeIcon,
        title: 'Access Additional Staff Tools',
        description: 'While you are there, send access details, reset passwords, update details, and more.'
    }

]
</script>